const PALETTES = {
  technical: ["#6f53d5", "#14b8a6", "#ff4032"],
  research:  ["#14b8a6", "#6f53d5", "#f3b640"],
  tutorial:  ["#ff4032", "#6f53d5", "#14b8a6"],
  opinion:   ["#f3b640", "#6f53d5", "#ff4032"],
  notes:     ["#6f53d5", "#f3b640", "#14b8a6"],
};

export default function coverSVG(kind = "technical", topic = "design") {
  const [c1, c2, c3] = PALETTES[kind] || PALETTES.technical;
  const seed = (topic + kind).length * 17;
  const y = 140 + (seed % 40);

  const svg = `
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 360'>
    <defs>
      <pattern id='p' width='18' height='18' patternUnits='userSpaceOnUse'>
        <circle cx='1' cy='1' r='1' fill='rgba(0,0,0,.08)'/>
      </pattern>
      <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0' stop-color='${c1}'/>
        <stop offset='1' stop-color='${c2}'/>
      </linearGradient>
    </defs>

    <rect width='100%' height='100%' fill='url(#p)'/>

    <!-- Bezier motif -->
    <path d='M40 ${y}C220 ${y-100} 420 ${y-100} 600 ${y}'
          fill='none' stroke='${c1}' stroke-width='6' stroke-linecap='round'/>
    <circle cx='220' cy='${y-100}' r='7' fill='${c1}'/>
    <circle cx='420' cy='${y-100}' r='7' fill='${c2}'/>

    <line x1='220' y1='${y-100}' x2='160' y2='${y-150}' stroke='${c1}' stroke-width='2'/>
    <line x1='420' y1='${y-100}' x2='520' y2='${y-170}' stroke='${c2}' stroke-width='2'/>
    <circle cx='160' cy='${y-150}' r='5' fill='${c1}'/>
    <circle cx='520' cy='${y-170}' r='5' fill='${c2}'/>

    <!-- Nib + type block -->
    <g transform='translate(420,220)'>
      <polygon points='0,0 36,18 0,100 -36,18' fill='#fff3db' stroke='rgba(0,0,0,.12)'/>
      <circle cx='0' cy='40' r='6' fill='${c3}'/>
    </g>

    <rect x='80' y='60' width='120' height='140' rx='16' fill='#fff' stroke='rgba(0,0,0,.12)'/>
    <rect x='98' y='86' width='84' height='18' rx='9' fill='${c3}'/>
    <rect x='98' y='112' width='70' height='10' rx='6' fill='rgba(0,0,0,.12)'/>

    <path d='M560 60l6 12 12 6-12 6-6 12-6-12-12-6 12-6 6-12Z'
          fill='${c3}' opacity='.9'/>
  </svg>`;

  return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
}
